import { createTheme } from "@mui/material/styles";

import { nucleus } from "../NucleusTheme";

export function generateMaterialTheme(theme) {
    return createTheme({
        palette: {
            primary: {
                main: theme.primary || nucleus.primary
            },
            secondary: {
                main: theme.secondary || nucleus.secondary
            },
            tertiary: {
                main: theme.tertiary || nucleus.tertiary
            }
        },
        components: {
            MuiButton: {
                styleOverrides: {
                    root: {
                        textTransform: "none",
                        fontSize: "1rem"
                    }
                }
            },
            MuiRadio: {
                defaultProps: {
                    color: "secondary"
                }
            }
        },
        typography: {
            fontFamily: "vag-rounded-light, Helvetica, Arial, sans-serif",
            button: {
                textTransform: "none"
            },
            h1: {
                fontSize: "2.125rem",
                fontWeight: 400,
                letterSpacing: "0.00735em",
                lineHeight: 1.235
            },
            h2: {
                fontSize: "1.5rem",
                fontWeight: 400,
                letterSpacing: "0em",
                lineHeight: 1.334
            },
            h3: {
                fontSize: "1.25rem",
                fontWeight: 500,
                letterSpacing: "0.0075em",
                lineHeight: 1.6
            },
            h4: {
                fontSize: "1.25rem",
                fontWeight: 500,
                letterSpacing: "0.0075em",
                lineHeight: 1.6
            },
            h5: {
                fontSize: "1.25rem",
                fontWeight: 500,
                letterSpacing: "0.0075em",
                lineHeight: 1.6
            },
            h6: {
                fontSize: "1.25rem",
                fontWeight: 500,
                letterSpacing: "0.0075em",
                lineHeight: 1.6
            }
        }
    });
}
